import { useQuery } from '@tanstack/react-query';

import { PUBLISHING_KD } from 'src/constants/services';
import { ResponseData } from 'src/interface/Commons';
import { fetchApiV3Publishing } from 'src/utils/fetch-api';

export const tcListQueryKey = ['tc-list'];

export interface EventTC {
	id: number;
	uidd: string;
	site: string;
	code: string;
	name: string;
	created_at: string;
	updated_at: string;
	created_by: string;
	updated_by: string;
}

const useTCList = () => {
	const { data, ...restAttributes } = useQuery({
		queryKey: tcListQueryKey,
		queryFn: (): Promise<ResponseData<{ records: EventTC[] }, {}>> =>
			fetchApiV3Publishing({
				url: `/${PUBLISHING_KD.service}/${PUBLISHING_KD.model.eventTc}/list`,
				options: { method: 'GET' },
			}),
	});

	return {
		data: data?.data?.records,
		...restAttributes,
	};
};

export default useTCList;
